module.exports = __webpack_public_path__ + "static/hexblood-cauldron-1c4e83e6fd9a98ea4c3d232828c08550.png";